var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSchedule = function SvgSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1a9.496 9.496 0 0 1 6.024 16.841c-3.024 2.479-7.248 2.845-10.569.96l-.26-.154-3.975 1.325a.542.542 0 0 1-.617-.2.547.547 0 0 1-.098-.39l.023-.102 1.335-3.893a9.489 9.489 0 0 1 7.826-14.382L11.5 1zM5.396 4.741A8.401 8.401 0 0 0 4.4 14.987a.55.55 0 0 1 .079.37l-.022.095L3.41 18.59l3.137-1.045a.54.54 0 0 1 .086-.022l.088-.007c.103 0 .205.03.292.085a8.377 8.377 0 0 0 4.487 1.307A8.4 8.4 0 1 0 5.396 4.74zm1.627 4.765a.994.994 0 1 1 0 1.988.994.994 0 0 1 0-1.988zm4.477 0a.994.994 0 1 1 0 1.988.994.994 0 0 1 0-1.988zm4.476 0a.994.994 0 1 1 0 1.988.994.994 0 0 1 0-1.988z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgSchedule;